<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Purchased Products</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" xs="12" md="3" class="subtitle-2 text--primary">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="date"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                @change="getRecords"
                v-model="date"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>

            <span>Total Sales: {{ totalSalesValue }}</span>
            <br />
            <span style="color: red" v-if="TotalReturns"
              >Total Returns: {{ TotalReturns.toLocaleString() }}</span
            >
            <br />
            <span>Diff: {{ totalSales - TotalReturns }}</span>
          </v-col>

          <v-col cols="12" md="8" class="align-content-end">
            <v-btn
              @click.native="summaryDialog = true"
              color="accent"
              text
              class="float-right"
              >Products Summary</v-btn
            >
          </v-col>

          <v-col cols="12">
            <v-text-field
              name="Search"
              v-model="search"
              label="Search"
              dense
            ></v-text-field>
            <!-- start of table -->
            <v-data-table
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="soldProducts"
              :search="search"
            >
              <!-- template -->
              <template v-slot:item.document.ocrd.Name="{ item }">
                <span>{{ item.document.ocrd.Name }}</span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.Price="{ item }">{{
                item.Price.toLocaleString()
              }}</template>
              <!-- end -->
              <!-- end -->
              <!-- template -->
              <template v-slot:item.LineTotal="{ item }">{{
                item.LineTotal.toLocaleString()
              }}</template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h3 style="color: red">Cancelled Products</h3>
          </v-col>

          <v-col cols="12" style="margin-top: -30px">
            <v-data-table
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="returnHeaders"
              :items="returnsData"
              :search="search"
            >
              <!-- template -->
              <template v-slot:item.Quantity="{ item }">
                <span style="color: red">{{
                  item.Quantity.toLocaleString()
                }}</span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.ocrd="{ item }">
                <span style="color: red">{{ item.ocrd.Name }}</span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.product="{ item }">
                <span style="color: red">{{ item.product.Name }}</span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.Price="{ item }">
                <span style="color: red">{{
                  item.Price.toLocaleString()
                }}</span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.LineTotal="{ item }">
                <span style="color: red">{{
                  item.LineTotal.toLocaleString()
                }}</span>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>

        <!--  Products summary dialog -->
        <v-dialog v-model="summaryDialog" max-width="950px">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Products Summary</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="summaryDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12" md="4">
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          outlined
                          single-line
                          v-model="record.StartDate"
                          label="From"
                          prepend-icon="mdi-calendar-month"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="record.StartDate"
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          outlined
                          single-line
                          v-model="record.EndDate"
                          label="From"
                          prepend-icon="mdi-calendar-month"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="record.EndDate"
                        @input="menu3 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-btn
                      color="primary"
                      small
                      :loading="loader"
                      @click="getReport"
                      >Query Data</v-btn
                    >
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-btn
                      text
                      color="accent"
                      @click="printSummary"
                      :loading="loader"
                      ><v-icon left color="black">mdi-printer</v-icon>Print
                      Summary</v-btn
                    >
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <v-data-table
                      :items-per-page="2000"
                      :mobile-breakpoint="0"
                      :headers="summaryHeaders"
                      :items="summaryData"
                      :search="search"
                    >
                      <template v-slot:item.TotalLineTotal="{ item }">
                        <span v-if="item.TotalLineTotal >= 0">{{
                          item.TotalLineTotal.toLocaleString()
                        }}</span>
                      </template>

                      <template v-slot:item.TotalQuantity="{ item }">
                        <span v-if="item.TotalQuantity >= 0">{{
                          item.TotalQuantity.toLocaleString()
                        }}</span>
                      </template>

                      <!-- <template v-slot:item.Item="{ item }">
                        <v-btn
                          color="primary"
                          text
                          @click="productsModal(item.Item.id)"
                          >{{ item.Item.Name
                          }}<v-icon small right>mdi-eye</v-icon></v-btn
                        >
                      </template> -->
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of products summary modal-->

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { http } from "@/common/index";
export default {
  data() {
    return {
      search: null,
      record: {},
      loader: false,
      summaryDialog: false,
      pageItems: 2000,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      summaryData: [],
      headers: [
        { text: "Customer", value: "document.ocrd.Name" },
        { text: "Cust. Ref", value: "document.ref2" },
        { text: "Product", value: "product.Name" },
        { text: "Qty", value: "Quantity" },
        { text: "UOM", value: "uomentry.UomName" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Sold By", value: "document.user.name" },
      ],
      summaryHeaders: [
        { text: "Item Name", value: "ItemName" },
        { text: "Total Qty", value: "TotalQuantity" },
      ],
      returnHeaders: [
        { text: "Customer", value: "ocrd" },
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "User", value: "User" },
      ],
      soldProducts: [],
      totalSales: null,
      returnsData: [],
      TotalReturns: null,
    };
  },
  computed: {
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    printSummary() {
      const dateRecord = this.record;
      const sales = this.summaryData;
      const stock = {
        StartDate: dateRecord.StartDate,
        EndDate: dateRecord.EndDate,
        sales: sales,
      };

      return http.post("http://localhost/print/products/summary", {
        stock,
      });
    },
    getReport() {
      const data = this.record;
      const url = "/sale-purchase-product-summary-report/14";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.summaryData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      const DocDate = this.date;
      const data = {
        StartDate: DocDate,
        SoldBy: null,
        ProductID: null,
        CustomerID: null,
        combinedReport: "N",
      };
      const self = this;
      this.$store.commit("loader", true);
      const url = `/bought-sold-products/14`;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.soldProducts = res.ResponseData.AllProductsSold;
            self.totalSales = res.ResponseData.TotalSalesAmount;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    returnedProducts() {
      const data = {
        StartDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10),
        CustomerID: null,
      };
      const self = this;
      const url = `/returned-products-report`;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.returnsData = res.ResponseData.AllSales;
            self.TotalReturns = res.ResponseData.TotalReturns;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRecords();
    this.returnedProducts();
  },
};
</script>

<style lang="scss" scoped>
</style>